import preact, { Component, h } from 'preact'
import Panel from '../panel'
import InputGroup from '../ui-components/InputGroup'
import { GroupData, HeroImageData } from './Overview'
import ImageUploader from '../category/control/ImageUploader'
import Button from '../ui-components/Button'
import Editor from '../editor'

interface Props extends GroupData {
  titleError?: string,
  descriptionError?: string,
  updateTitle: (title: string) => void,
  updateDescription: (description: string) => void,
  updateHeroImage: (heroImage: null|HeroImageData) => void
}

interface State{
}

export class GroupInfoPanel extends Component<Props, State> {
  uploader: preact.RefObject

  render ({ title, updateTitle, description, updateDescription, heroImage, updateHeroImage, titleError, descriptionError  }: Props, state: State) {
    return (
      <Panel title='Group details'>
        <InputGroup
          title='Group name'
          type='text'
          error={titleError}
          placeholder='Add a name'
          onChange={(e: {target: HTMLInputElement}) => updateTitle(e.target.value) }
          value={title} />

        <div className={`group-page_description ${descriptionError ? 'error' : ''}`}>
          <label>About this group</label>
          <Editor
            isControl
            data={description}
            CKEditor={false}
            canHavePoll={false}
            onChange={(content: string) => {
              updateDescription(content)
            }} />
          {
            descriptionError ? <p className='error'> { descriptionError } </p> : null
          }
        </div>

        <div className='group-page_hero'>
          <label>Hero image (optional)</label>
          <p>Hero image will be shown on top of the group page <br />
            Maximum file size: 5MB. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px </p>
          {
            heroImage ? (
              <div className='hero-image-container'>
                <div className='hero-image-wrapper'>
                  <img src={heroImage.source_thumb} />
                  <a target='_blank' href={heroImage.source_thumb} className='component-uploader__image-details'>
                    2880 &times; 480px <i className='icon icon-external' />
                  </a>
                </div>
                <div className='hero-image_buttons'>
                  <Button
                    type='button'
                    class='btn-default btn--insided-secondary-brand'
                    onClick={() => this.uploader.click()}
                  >
                    Edit
                  </Button>
                  <Button
                    type='button'
                    class='btn-default btn--insided-secondary-brand btn-delete'
                    onClick={() => updateHeroImage(null)}
                  >
                    Remove
                  </Button>
                </div>
              </div>
            ) : (
              <div>
                <Button
                  type='button'
                  class='btn-default'
                  onClick={() => this.uploader.click()}
                >
                  Upload image
                </Button>
              </div>
            )
          }
          <ImageUploader
            width={2880}
            height={480}
            onUploaded={(data: HeroImageData) => updateHeroImage(data)}
            uploaderRef={(ref: preact.RefObject) => {
              this.uploader = ref
            }}
          />
        </div>
      </Panel>
    )
  }
}

export default GroupInfoPanel
